import { useParams, useLocation, useSearchParams, useNavigate } from 'react-router-dom';

export function useVerseRouteParams() {
  const { ch, vs } = useParams<{ ch: string; vs?: string }>();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const scrollParam = searchParams.get('p');
  return { ch, vs, pathname: location.pathname, scrollParam };
}

export function useAppNavigate() {
  return useNavigate();
}

export function usePathname() {
  const location = useLocation();
  return location.pathname;
}

export function replaceRoute(path: string) {
  window.history.replaceState(null, '', path);
}
